export enum FilterableIndexItemListVariant {
  CITY = 'city',
  UF = 'uf',
}

export enum FilterableIndexItemListType {
  SPECIALTY = 'specialty',
  EXAM = 'exam',
}
